import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { errorText } from '../utils/errors';

export function useApiMutation({ mutationFn, optimistic, invalidate, success, error, ...rest }) {
  const qc = useQueryClient();

  return useMutation({
    ...rest,
    mutationFn,
    onMutate: optimistic
      ? async (variables) => {
          const patches = optimistic(variables);
          await Promise.all(patches.map(({ key }) => qc.cancelQueries({ queryKey: key })));
          const snapshot = patches.flatMap(({ key }) => qc.getQueriesData({ queryKey: key }));
          patches.forEach(({ key, update }) =>
            qc.setQueriesData({ queryKey: key }, (data) => (data === undefined ? data : update(data)))
          );
          return { snapshot };
        }
      : undefined,
    onSuccess: (data, variables) => {
      const text = typeof success === 'function' ? success(data, variables) : success;
      if (text) toast.success(text);
    },
    onError: (err, _variables, context) => {
      context?.snapshot?.forEach(([key, data]) => qc.setQueryData(key, data));
      if (error) toast.error(errorText(err, error));
    },
    onSettled: () => invalidate?.forEach((key) => qc.invalidateQueries({ queryKey: key }))
  });
}
